import { Address, PublicClient } from 'viem';

import { api, cacheTags, IConnectedActionParams } from 'modules/api';
import { getPublicClient } from 'modules/api/getPublicClient';
import { asAddress } from 'modules/api/utils/asAddress';
import { getWalletClient } from 'modules/api/walletClient';

import { isPoolOwner } from '../methods/isPoolOwner';

interface IGetOwnerPoolAddressesArgs extends IConnectedActionParams {
  poolAddress: Address;
}

export const {
  useGetIsOwnerPoolQuery,
  endpoints: { getIsOwnerPool: getIsOwnerPoolEndpoint },
} = api.injectEndpoints({
  endpoints: build => ({
    getIsOwnerPool: build.query<boolean, IGetOwnerPoolAddressesArgs>({
      queryFn: async ({ poolAddress }) => {
        const walletClient = getWalletClient();
        const getIsPoolOwner = (client: PublicClient) =>
          isPoolOwner(client, {
            poolAddress,
            accountAddress: asAddress(walletClient.account?.address),
          });

        try {
          return {
            data: await getIsPoolOwner(getPublicClient()),
          };
        } catch {
          return {
            data: await getIsPoolOwner(getPublicClient()),
          };
        }
      },
      providesTags: [cacheTags.pools, cacheTags.account],
    }),
  }),
});
